/* eslint-disable react/no-unknown-property */
import React from "react";
import { IIcons } from "./icons";

const UFO = ({ fillColor, width = "297", height = "297" }: IIcons.IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 297 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={fillColor}
    >
      <g clip-path="url(#clip0_219_1649)">
        <path
          opacity="0.3"
          d="M296.945 282.734C296.945 289.9 255.123 295.81 201.136 296.655C187.124 296.874 172.773 296.751 158.956 296.264C112.674 294.639 78.6523 289.198 78.6523 282.734C78.6523 274.988 127.52 268.707 187.8 268.707C248.08 268.707 296.947 274.988 296.947 282.734H296.945Z"
          fill="#757575"
        />
        <path
          d="M168.924 278.313C170.036 278.296 170.587 278.288 171.684 278.271C177.255 278.088 182.803 279.164 188.297 279.916C192.292 280.415 196.357 280.809 200.385 280.779C204.42 280.749 207.028 280.305 206.51 279.558C205.422 277.99 202.895 276.47 201.069 274.972C204.749 273.964 208.361 272.835 211.968 271.586C215.124 274.538 220.63 277.664 221.742 280.042C223.402 283.591 210.845 289.857 206.64 289.89C198.97 289.947 191.884 285.467 184.361 282.901C179.85 281.364 174.795 281.223 170.026 281.306C169.204 281.311 168.794 281.313 167.972 281.318C168.305 280.119 168.378 280.563 168.924 278.313ZM154.042 276.986C156.557 277.074 163.446 278.998 163.145 280.104C162.784 281.439 154.739 281.928 151.563 281.943C149.333 281.956 141.1 280.892 141.172 280.227C141.308 279.006 150.34 276.856 154.04 276.984L154.042 276.986Z"
          fill="black"
        />
        <path
          d="M140.981 88.9653C177.258 83.4973 203.735 59.5704 200.121 35.5232C196.506 11.4759 164.168 -3.58552 127.891 1.88249C91.6149 7.3505 65.1372 31.2774 68.7518 55.3246C72.3664 79.3719 104.705 94.4333 140.981 88.9653Z"
          fill="#0F5BF1"
        />
        <path
          d="M139.853 81.4661C169.88 76.94 191.797 57.1349 188.805 37.2303C185.813 17.3256 159.046 4.85878 129.018 9.38487C98.9905 13.911 77.0739 33.716 80.0658 53.6207C83.0577 73.5253 109.825 85.9921 139.853 81.4661Z"
          fill="#6E9FFF"
        />
        <path
          d="M147.287 14.7412C153.611 14.7025 158.721 11.7153 158.698 8.06921C158.676 4.42308 153.531 1.49868 147.206 1.53737C140.881 1.57606 135.772 4.56319 135.794 8.20932C135.816 11.8555 140.962 14.7799 147.287 14.7412Z"
          fill="#0F5BF1"
        />
        <g opacity="0.5">
          <path
            d="M91.6227 22.3418C87.7301 25.6554 83.9001 29.9321 80.4609 35.4631C80.4609 35.4631 84.862 33.6796 89.9043 33.1754C89.9043 33.1754 92.9753 28.8736 98.6864 23.8644L91.6227 22.3418Z"
            fill="white"
          />
          <path
            d="M103.004 20.3694C107.786 16.805 113.785 13.2907 120.881 11.0257C120.881 11.0257 109.113 10.4187 96.5664 18.6361L103.004 20.3694Z"
            fill="white"
          />
        </g>
        <path
          d="M254.48 40.1043C255.394 46.1796 249.611 52.8368 238.865 59.3485C238.116 59.8025 237.349 60.249 236.55 60.703C216.501 72.086 181.526 82.8469 140.984 88.9598C100.443 95.0727 63.854 95.1003 41.3451 90.1337C40.4484 89.9355 39.5842 89.7349 38.7351 89.5217C26.5488 86.4665 19.0668 81.8084 18.1525 75.7332C16.4867 64.6587 37.1194 51.6027 69.53 41.1001C70.7298 40.7063 71.9572 40.325 73.1946 39.9438C90.1802 34.6737 110.132 30.1235 131.651 26.8777C153.17 23.6344 173.578 22.0992 191.36 22.1293C192.652 22.1293 193.94 22.1319 195.202 22.1544C229.264 22.636 252.819 29.0299 254.485 40.1043H254.48Z"
          fill="#DFC9BE"
        />
        <path
          d="M73.1915 39.9434C62.8563 56.8498 52.2432 73.5856 41.3445 90.1333C40.4477 89.9351 39.5835 89.7345 38.7344 89.5213C49.2524 73.5505 59.5223 57.4041 69.5293 41.1022C70.7292 40.7084 71.9566 40.3271 73.194 39.9459L73.1915 39.9434Z"
          fill="#0F102E"
        />
        <path
          d="M238.863 59.3481C238.114 59.8021 237.348 60.2486 236.548 60.7026C221.269 48.1005 206.202 35.2376 191.355 22.1289C192.648 22.1289 193.935 22.1314 195.198 22.154C209.556 34.7836 224.117 47.1875 238.863 59.3481Z"
          fill="#0F102E"
        />
        <path
          d="M140.981 88.9669C216.464 77.5892 275.791 55.9601 273.491 40.6569C271.19 25.3537 208.134 22.1715 132.651 33.5492C57.1678 44.9269 -2.15871 66.5561 0.141541 81.8592C2.4418 97.1624 65.4978 100.345 140.981 88.9669Z"
          fill="#7D716A"
        />
        <path
          d="M140.979 88.9652C216.462 77.5875 275.88 56.5669 273.692 42.0144C271.505 27.462 208.541 24.8883 133.057 36.266C57.5741 47.6437 -1.84394 68.6643 0.343476 83.2168C2.53089 97.7692 65.4954 100.343 140.979 88.9652Z"
          fill="#E6E6E6"
        />
        <path
          d="M140.98 88.9637C196.576 80.5835 240.315 64.9292 238.672 53.9987C237.029 43.0683 190.627 41.0009 135.03 49.381C79.4333 57.7612 35.6952 73.4156 37.3382 84.346C38.9811 95.2765 85.3831 97.3438 140.98 88.9637Z"
          fill="#D6D6D6"
        />
        <path
          d="M193.133 63.3724C194.574 72.9468 171.323 84.385 141.207 88.9251C111.091 93.4653 85.5113 89.3892 84.071 79.8122C83.7053 77.3791 84.9377 74.8231 87.4677 72.2871C94.8946 64.8624 113.536 57.6358 135.995 54.2495C158.453 50.8632 178.392 52.2729 187.675 57.1792C190.839 58.8573 192.768 60.9368 193.133 63.3699V63.3724Z"
          fill="#151740"
        />
        <path
          d="M187.672 57.1812C180.245 64.616 161.607 71.8401 139.145 75.2264C116.687 78.6127 96.7479 77.203 87.4648 72.2891C94.8918 64.8643 113.533 57.6377 135.992 54.2514C158.451 50.8651 178.389 52.2748 187.672 57.1812Z"
          fill="#0F102E"
        />
        <path
          opacity="0.2"
          d="M193.133 63.3711C194.573 72.9455 171.323 84.3837 141.207 88.9238C111.09 93.464 85.5106 89.3879 84.0703 79.8135L90.9387 265.591L284.989 281.767L193.133 63.3711Z"
          fill="url(#paint0_linear_219_1649)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_219_1649"
          x1="176.877"
          y1="272.759"
          x2="194.199"
          y2="65.027"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stop-color="#00FFFF" stop-opacity="0" />
          <stop offset="0.16" stop-color="#10FFFF" stop-opacity="0.12" />
          <stop offset="0.26" stop-color="#21FFFF" stop-opacity="0.26" />
          <stop offset="0.37" stop-color="#2FFFFF" stop-opacity="0.36" />
          <stop offset="0.48" stop-color="#39FFFF" stop-opacity="0.44" />
          <stop offset="0.59" stop-color="#3FFFFF" stop-opacity="0.49" />
          <stop offset="0.7" stop-color="#41FFFF" stop-opacity="0.5" />
          <stop offset="0.71" stop-color="#3EFFFF" stop-opacity="0.52" />
          <stop offset="0.85" stop-color="#1CFFFF" stop-opacity="0.78" />
          <stop offset="0.95" stop-color="#08FFFF" stop-opacity="0.94" />
          <stop offset="1" stop-color="#00FFFF" />
        </linearGradient>
        <clipPath id="clip0_219_1649">
          <rect
            width="296.866"
            height="296"
            fill="white"
            transform="translate(0.078125 0.757812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UFO;
